import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .hasSection()
    .hasTemplate()
    .sluggable()
    .sortable()
    .selfReferential()
    .hasTitle()
	.hasLede()
	.hasSummary()
    .hasBody()
    .publishable()
    .publishableByDate()
    .hasTimestamps()
    .make();

export default schema;
